import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { checkBrowserStatus } from '@le_cedre/portal-lib';
import { lastValueFrom, Subject } from 'rxjs';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@le_cedre/design-system';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-portal-email-unsubscribe',
    template: `
        <div class="portal-email-form-container email-container">
            <div class="portal-login__form-content" *ngIf="checkBrowserStatus() !== 'Not Supported'">
                <form (submit)="unsubscribeEmail()" [formGroup]="emailForm" *ngIf="!succeeded && !failed">
                    <div class="portal-login__title">
                        <span
                            class="card-title connect-title"
                            [innerHTML]="'UNSUBSCRIBE_EMAIL_TITLE' | translate"
                        ></span>
                    </div>

                    <div
                        class="portal-login__email form-spacing loginradius--form-element-content content-loginradius-emailid"
                    >
                        <label
                            class="login-email__label"
                            for="loginradius-login-emailid"
                            [innerHTML]="'FORM_LABEL_EMAIL' | translate"
                        ></label>
                        <input
                            class="login-email__input loginradius-string loginradius-emailid lr-required"
                            [class.error-field]="emailForm.get('email').errors && emailForm.dirty"
                            type="text"
                            name="emailid"
                            id="loginradius-login-emailid"
                            formControlName="email"
                        />
                        <div class="error-message" *ngIf="emailForm.get('email').errors">
                            <span
                                *ngIf="emailForm.get('email').errors.required"
                                [innerHTML]="'FORM_ERROR_REQUIRED' | translate"
                            ></span>
                            <span
                                *ngIf="emailForm.get('email').errors.pattern"
                                [innerHTML]="'FORM_ERROR_EMAIL' | translate"
                            ></span>
                        </div>
                    </div>
                    <div class="portal-login__connect form-spacing">
                        <ds-button
                            class="email-button"
                            type="submit"
                            [label]="'UNSUBSCRIBE' | translate"
                            aspect="primary"
                            shape="square"
                        ></ds-button>
                    </div>
                    <div class="portal-login__separator form-spacing" *ngIf="displaySsoButton">
                        <span [innerHTML]="'OR' | translate" class="or-separator"></span>
                    </div>
                </form>
                <div class="portal-login__title" *ngIf="failed">
                    <span class="card-title center" [innerHTML]="'UNSUBSCRIBE_EMAIL_FAILED_TITLE' | translate"></span>
                </div>
                <div class="portal-login__title" *ngIf="succeeded">
                    <span
                        class="card-title center"
                        [innerHTML]="'UNSUBSCRIBE_EMAIL_SUCCEEDED_TITLE' | translate"
                    ></span>
                </div>
            </div>
            <div *ngIf="checkBrowserStatus() === 'Not Supported'" class="portal-login__browser-container">
                <div class="portal-login__title">
                    <span
                        class="card-title connect-title"
                        [innerHTML]="'LOGIN_BROWSER_NOT_SUPPORTED_TITLE' | translate"
                    ></span>
                </div>
                <div
                    class="portal-login__browser-text"
                    [innerHTML]="'LOGIN_BROWSER_NOT_SUPPORTED_TEXT' | translate"
                ></div>
            </div>
        </div>
    `,
    styleUrls: ['./email-unsubscribe.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgIf, ReactiveFormsModule, TranslateModule, ButtonComponent],
})
export class EmailUnsubscribeComponent implements OnInit, OnDestroy {
    emailForm: UntypedFormGroup;
    emailToUnsubscribe: string;
    uid: string;
    succeeded: boolean;
    failed: boolean;

    destroy$ = new Subject();
    checkBrowserStatus = checkBrowserStatus;
    displaySsoButton: boolean = false;

    constructor(private route: ActivatedRoute, private httpClient: HttpClient) {}

    ngOnInit() {
        this.emailForm = new UntypedFormGroup({
            email: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
        });

        this.route.queryParams.subscribe((params) => {
            const email = params['email'];
            const uid = params['uid'];

            if (email) {
                this.emailForm.patchValue({ email });
            }

            this.emailToUnsubscribe = email;
            this.uid = uid;
        });
    }

    get email() {
        return this.emailForm.get('email');
    }

    unsubscribeEmail() {
        const payload = {
            email: this.emailToUnsubscribe,
            uid: this.uid,
        };
        lastValueFrom(this.httpClient.post(`${environment.urls.v2}hub/public/email/unsubscribe`, payload))
            .then(() => {
                this.succeeded = true;
            })
            .catch((error) => {
                this.failed = true;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
